/**
 * @hidden
 */
export var messages = Object.create({});
//# sourceMappingURL=messages.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-intl/dist/es/Localization/messages.js
// module id = 472
// module chunks = 0